// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-docs-page-js": () => import("./../../../src/templates/DocsPage.js" /* webpackChunkName: "component---src-templates-docs-page-js" */),
  "component---src-templates-folder-page-js": () => import("./../../../src/templates/FolderPage.js" /* webpackChunkName: "component---src-templates-folder-page-js" */)
}

